import { render, staticRenderFns } from "./CargoQuickInfo.vue?vue&type=template&id=256f9f99&"
import script from "./CargoQuickInfo.vue?vue&type=script&lang=js&"
export * from "./CargoQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuickInfo.vue"
export default component.exports